// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"541801e9","622":"b6405c68"}[chunkId] + ".chunk.js";
};